module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"read_more":"Read more"},"pt-BR":{"read_more":"Leia mais"}}')
  delete Component.options._Ctor
}
